export const DEFAULT_BOARD_CANVAS_SIZE = 800;
